import React, { useEffect, useState } from 'react';

// Stylesheet import
import classes from '../FansAndFavourites/FansAndFavourites.module.css';

// React icons
import { FiUserCheck, FiUserPlus, FiX } from 'react-icons/fi';

// tooltip imported
import MyToolTip from '../../CommonComponents/MyToolTip';

// Material UI Stuff imported
import { Avatar, Box, Grow, Modal } from '@mui/material';

// API Base URL imported
import API from '../../../Axios/axios';
import { useDispatch, useSelector } from 'react-redux';
import { updateFavouritesCount } from '../../../Store/userProfileSlice';
import { useNavigate } from 'react-router-dom';
import { apiErrorCodes } from '../../../apiErrorCodes';

export default function Fans(props) {
  const [open, setOpen] = useState(false);
  const [fans, setFans] = useState('');
  const [status, setStatus] = useState('loading');
  const token = localStorage.getItem('token');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userProfileData } = useSelector((state) => state.userProfileSlice);

  // Function to open the URL in new tab
  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  // Function to redirect to the profile of creator
  const creatorNameClickHandler = (profileId) => {
    if (profileId === userProfileData.id) {
      navigate(`/userprofile`);
    } else {
      openInNewTab(`/accounts/${profileId}/profile/`);
    }
  };

  // Function to remove that creator form the favorite list of the login user
  const removeFavouritesHandler = async (element) => {
    try {
      const response = await API.post(
        `${element.follow_url}`,
        {},
        {
          headers: {
            Authorization: `token ${token}`,
          },
        }
      );
      dispatch(updateFavouritesCount(response.data.message.total_favourites));
      const result = fans.map((option) => {
        if (option.user.id === element.id) {
          option.user.status = false;
        }
        return option;
      });
      setFans(result);
    } catch (error) {
      if (
        error.response.data.code === apiErrorCodes.INVALID_TOKEN ||
        error.response.data.code === apiErrorCodes.AUTHENTICATION_FAILED ||
        error.response.data.code === apiErrorCodes.ACCOUNT_NOT_EXIST ||
        error.response.data.code === apiErrorCodes.USERNAME_NOT_FOUND
      ) {
        localStorage.removeItem('token');
        navigate('/entry/signin');
      }
    }
  };

  // Function to add that creator to the favorite list of the login user
  const addFavouritesHandler = async (element) => {
    try {
      // using axios
      const response = await API.post(
        `${element.follow_url}`,
        {},
        {
          headers: {
            Authorization: `token ${token}`,
          },
        }
      );
      dispatch(updateFavouritesCount(response.data.message.total_favourites));
      const result = fans.map((option) => {
        if (option.user.id === element.id) {
          option.user.status = true;
        }
        return option;
      });
      setFans(result);
    } catch (error) {
      if (
        error.response.data.code === apiErrorCodes.INVALID_TOKEN ||
        error.response.data.code === apiErrorCodes.AUTHENTICATION_FAILED ||
        error.response.data.code === apiErrorCodes.ACCOUNT_NOT_EXIST ||
        error.response.data.code === apiErrorCodes.USERNAME_NOT_FOUND
      ) {
        localStorage.removeItem('token');
        navigate('/entry/signin');
      }
    }
  };

  useEffect(() => {
    // To get the list of favorites
    (async () => {
      try {
        const response = await API.get(
          `accounts/creator/${props.id}/fans_list/`,
          {
            headers: {
              Authorization: `token ${token}`,
            },
          }
        );
        if (response.data.code === apiErrorCodes.SUCCESS) {
          setFans(response.data.message);
          setStatus('Done');
          if (response.data.message.length > 0) {
            // This will only open the modal if the user have at least one fan
            setOpen(true);
          }
        }
      } catch (error) {
        if (
          error.response.data.code === apiErrorCodes.INVALID_TOKEN ||
          error.response.data.code === apiErrorCodes.AUTHENTICATION_FAILED ||
          error.response.data.code === apiErrorCodes.ACCOUNT_NOT_EXIST
        ) {
          localStorage.removeItem('token');
          navigate('/entry/signin');
        }
      }
    })();
  }, []);

  useEffect(() => {
    // This will close the modal if the user does not have any fans
    if (fans.length < 1) {
      setOpen(false);
    }
  }, [fans]);

  if (status === 'loading') {
    return '';
  }

  return (
    <>
      <Modal open={open} onClose={props.handleSubmit}>
        <div>
          <Grow in={true}>
            <Box className={classes.favouritesModal}>
              <Box className={classes.favouritesModalHeader}>
                <FiX className="cross-button" onClick={props.handleSubmit} />
                <h4 className={classes.favouritesModalHeading}>FANS</h4>
              </Box>

              <Box className={classes.favouritesModalBody}>
                {fans?.map((element) => (
                  <div className={classes.element} key={element.id}>
                    <Avatar
                      src={element.user.profile_pic}
                      className={classes.avatar}
                      onClick={() => creatorNameClickHandler(element.user.id)}
                      alt="avatar_img"
                    />
                    <div className={classes.description}>
                      <h4
                        className={`element-heading ${classes.profileName}`}
                        onClick={() => creatorNameClickHandler(element.user.id)}
                      >
                        {element.user.name}
                      </h4>
                      <p className="element-description">
                        {element.user.top_interest}
                      </p>
                    </div>
                    {'status' in element.user ? (
                      <>
                        {element.user.status ? (
                          <MyToolTip title="Favourite" placement="left">
                            <div>
                              <FiUserCheck
                                onClick={() => {
                                  removeFavouritesHandler(element.user);
                                }}
                                className={classes.fiUserCheck}
                              />
                            </div>
                          </MyToolTip>
                        ) : (
                          <MyToolTip title="Be a Fan" placement="left">
                            <div>
                              <FiUserPlus
                                onClick={() => {
                                  addFavouritesHandler(element.user);
                                }}
                                className={classes.follow}
                              />
                            </div>
                          </MyToolTip>
                        )}
                      </>
                    ) : (
                      ''
                    )}
                  </div>
                ))}
              </Box>
            </Box>
          </Grow>
        </div>
      </Modal>
    </>
  );
}
